export const T = {
  en_GB: {
    notApplicable:
      "Sustainability matching appears here once the sustainability preferences are filled in (and marked as important).",
    notEvaluable: "The matching table appears once the portfolio has been set up.",
    product: "Product",
    weight: "Weight",
    meets: "Meets",
    doesNotMeet: "Does not meet",
    sfdr: "SFDR",
    portfolioRow: "Portfolio",
    statusLabel: "Sustainability status",
    statusOk: "Suitable",
    statusDeviation: "Deviation",
    statusAccepted: "Accepted",
    statusNotAccepted: "Not accepted",
    modeIndividual: "Product matching — every instrument must meet the preferences.",
    modePortfolio: (threshold: string) =>
      `Portfolio matching — at least ${threshold}% of the portfolio must meet them.`,
    weightMeeting: (pct: string) => `${pct}% of the portfolio meets the preferences`,
    decisionTitle: "Deviation decision",
    decisionDescription:
      "The portfolio deviates from the client's sustainability preferences. Accept the deviation or mark the goal as do-not-proceed.",
    decisionAccept: "Accept",
    decisionDoNotProceed: "Do not proceed",
    justificationLabel: "Justification (optional)",
    save: "Save",
    decisionSavedBy: "Decision recorded",
    justification: "Justification",
    incompleteMessage: "Resolve the sustainability deviation before submitting.",
    deviationNoOverride:
      "This portfolio deviates from the client's sustainability preferences. It must be resolved by changing the preferences or the portfolio before submitting.",
  },
  nb_NO: {
    notApplicable:
      "Bærekraftsmatching vises her når bærekraftspreferansene er fylt ut (og markert som viktige).",
    notEvaluable: "Matchingtabellen vises når porteføljen er satt opp.",
    product: "Produkt",
    weight: "Vekt",
    meets: "Oppfyller",
    doesNotMeet: "Oppfyller ikke",
    sfdr: "SFDR",
    portfolioRow: "Portefølje",
    statusLabel: "Bærekraftsstatus",
    statusOk: "Egnet",
    statusDeviation: "Avvik",
    statusAccepted: "Akseptert",
    statusNotAccepted: "Ikke akseptert",
    modeIndividual: "Produktmatching — hvert instrument må oppfylle preferansene.",
    modePortfolio: (threshold: string) =>
      `Porteføljematching — minst ${threshold}% av porteføljen må oppfylle dem.`,
    weightMeeting: (pct: string) => `${pct}% av porteføljen oppfyller preferansene`,
    decisionTitle: "Avviksbeslutning",
    decisionDescription:
      "Porteføljen avviker fra kundens bærekraftspreferanser. Aksepter avviket eller marker målet som ikke videre.",
    decisionAccept: "Aksepter",
    decisionDoNotProceed: "Ikke gå videre",
    justificationLabel: "Begrunnelse (valgfritt)",
    save: "Lagre",
    decisionSavedBy: "Beslutning registrert",
    justification: "Begrunnelse",
    incompleteMessage: "Løs bærekraftsavviket før innsending.",
    deviationNoOverride:
      "Denne porteføljen avviker fra kundens bærekraftspreferanser. Det må løses ved å endre preferansene eller porteføljen før innsending.",
  },
} as const;
